<div [formGroup]="parent">
  <h2 class="form-head">Details</h2>
  <div class="required">Required *</div>
  <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px">
    <mat-form-field fxFlex="50%">
      <mat-label>Title</mat-label>
      <input
        matInput
        type="text"
        formControlName="displayName"
        (change)="onChange()"
        />
      <mat-error
        print-error
        [control]="parent?.get('displayName')"
        fieldName="Bundle title"
        >
      </mat-error>
    </mat-form-field>

    @if (programs && programs.length > 0) {
      <mat-form-field fxFlex="50%">
        <mat-label>Program *</mat-label>
        <mat-select
          placeholder="Program *"
          [value]="editionId"
          (selectionChange)="onProgramValueChange($event.value)"
          [disabled]="disableProgramSelect"
          >
          @for (program of programs; track trackByProgram($index, program)) {
            <mat-option
              [value]="program?.editionId"
              >
              {{ program?.editionName }}
            </mat-option>
          }
        </mat-select>
        <mat-error
          print-error
          [control]="parent?.get('editionId')"
          fieldName="Program"
          >
        </mat-error>
      </mat-form-field>
    }
  </div>

  <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px">
    <mat-form-field fxFlex="15%">
      <mat-label>{{levelLabel}}</mat-label>
      <mat-select
        formControlName="levelIds"
        (selectionChange)="onChange()"
        >
        @for (level of lessonLevels; track level) {
          <mat-option
            [value]="level.levelId"
            >
            {{ level?.levelName }}
          </mat-option>
        }
      </mat-select>
      <mat-error
        print-error
        [control]="parent?.get('levelIds')"
        fieldName="{{ levelLabel }}"
        >
      </mat-error>
    </mat-form-field>

    @if (subjectId && !ifMathProgram()) {
      <mat-form-field fxFlex="15%">
        <mat-label>Unit</mat-label>
        <mat-select
          formControlName="unit"
          (selectionChange)="onChange()"
          >
          @for (unit of lessonUnits; track unit) {
            <mat-option [value]="unit">
              {{ unit }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    <!-- Score Possible -->
    <mat-form-field fxFlex="25%">
      <mat-label>Score Possible</mat-label>
      <input
        matInput
        type="text"
        formControlName="scorePossible"
        (change)="onChange()"
        />
      <mat-error
        print-error
        [control]="parent?.get('scorePossible')"
        fieldName="Score Possible"
        >
      </mat-error>
    </mat-form-field>

    <mat-form-field fxFlex>
      <mat-label>Share With</mat-label>
      <mat-select
        formControlName="visibility"
        (selectionChange)="onChange()"
        >
        @for (opt of visibilityOpts; track opt) {
          <mat-option
            [value]="opt.key"
            >
            {{ opt.value }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div class="bundleDescription">
    <label
      >Description *
      <text-editor
        placeholder="Bundle description *"
        formControlName="description"
        [required]="true"
        (onContentChanged)="onChange()"
        (setQuillEditorTouched)="setQuillEditorTouched()"
      ></text-editor>
    </label>
    <mat-error
      print-error
      [control]="parent?.get('description')"
      fieldName="Bundle description"
      >
    </mat-error>
  </div>
</div>
